// components/ResponsiveHidden.tsx

import { useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';

type ResponsiveHiddenProps = {
  children: React.ReactNode;
  xsDown?: boolean;
  smOnly?: boolean;
  smUp?: boolean;
  mdDown?: boolean;
  lgUp?: boolean;
};

const ResponsiveHidden: React.FC<ResponsiveHiddenProps> = ({
  children,
  xsDown,
  smOnly,
  smUp,
  mdDown,
  lgUp,
}) => {
  const theme = useTheme();
  const xsDownMatch = useMediaQuery(theme.breakpoints.down('xs'));
  const smOnlyMatch = useMediaQuery(theme.breakpoints.only('sm'));
  const smUpMatch = useMediaQuery(theme.breakpoints.up('sm'));
  const mdDownMatch = useMediaQuery(theme.breakpoints.down('md'));
  const lgUpMatch = useMediaQuery(theme.breakpoints.up('lg'));

  const hide =
    (xsDown && xsDownMatch) ||
    (smOnly && !smOnlyMatch) ||
    (smUp && smUpMatch) ||
    (mdDown && mdDownMatch) ||
    (lgUp && lgUpMatch);

  return hide ? null : <>{children}</>;
};

export default ResponsiveHidden;
